import styled, {css} from 'styled-components'

import theme, {media} from '@/src/config/theme'

import {Link} from '@/src/shared/ui/link'
import {NewsTile as NewsTile_} from '@/src/entities/news'


export const Wrapper = styled.div``

export const TagLink = styled(Link)``

const ActiveTagStyle = css`
  color: ${theme.colors.textLink};

  background: ${theme.colors.primary};

  span {
    border-color: ${theme.colors.textLink};
  }
`

export const Tag = styled.div<{$active?: boolean}>`
  & ${TagLink} {
    font-weight: 300;
    padding: 6px 12px;
    border-radius: 5px;

    ${props => props.$active && ActiveTagStyle}

    &:hover {
      ${ActiveTagStyle}
    }
  }
`

export const Pagination = styled.div`
  max-width: unset;
  width: 100%;

  &.ant-pagination {
    justify-content: flex-end;
  }
`

export const Articles = styled.div`
  padding: 27px 0;

  display: flex;
  flex-direction: column;
  gap: 10px;

  @media ${media.md} {
    gap: 25px;
  }

  @media ${media.lg} {
    gap: 38px;
  }
`

export const ArticleContainer = styled.div`
  display: flex;
  gap: 15px;
  flex-direction: column;

  & > * {
    flex: 1;
  }

  @media ${media.md} {
    gap: 25px;

    flex-direction: row;
  }

  @media ${media.lg} {
    gap: 38px;
  }
`

export const NewsTile = styled(NewsTile_)``

export const NewsTileTitle = styled(Link)`
  margin-top: 3px;

  font-size: 1.875rem;
  font-weight: 450;

  & span {
    display: unset;
    white-space: normal;
    text-decoration: underline;
    text-underline-offset: 4px;
    line-height: 1.5;
  }
`

export const ArticleContent = styled.div`
  display: flex;
  flex-direction: column;

  gap: 15px;
`
export const NewsTileDescription = styled.div`
  margin-top: 5px;

  @media ${media.md} {
    display: -webkit-box;
    -webkit-line-clamp: 8;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  @media ${media.lg} {
    -webkit-line-clamp: 15;
  }
`

export const Alert = styled.div`
  border: solid 1px ${theme.colors.primary};

  & .ant-alert-description {
    color: ${theme.colors.primary};
  }

  background: transparent;
`
